import IndexView from "@/index/IndexView.vue";
import FindSymptoms from "@/views/FindSymptoms.vue";
import FaultView from "@/views/FaultView.vue";
import FindRepair from "@/views/FindRepair.vue";
import RepairView from "@/views/RepairView.vue";
import EstimateRepair from "@/views/EstimateRepair.vue";
import Profile from "@/views/Profile.vue";
import TecEstimateList from "@/views/TecEstimateList.vue";
import TecEstimateDetail from "@/views/TecEstimateDetail.vue";
import TecEstimateVariant from "@/views/TecEstimateVariant.vue";
import SocialSignUp from "@/views/SocialSignUp.vue";
import NotFound from "@/views/NotFound.vue";
import { createRouter as createVueRouter, createWebHistory } from "vue-router";
import ActivationView from "@/accounts/ActivationView.vue";
import LoginView from "@/accounts/LoginView.vue";
import ForgotPasswordView from "@/accounts/ForgotPasswordView.vue";
import NewPasswordView from "@/accounts/NewPasswordView.vue";
import CookiesDeclarationSettings from "@/components/CookiesDeclarationSettings.vue";
import RegistrationView from "@/accounts/RegistrationView.vue";

export function createRouter(appContainer: HTMLElement) {
  const csrf = appContainer!.dataset.csrf;
  const socialEmail = appContainer!.dataset.socialEmail;
  const socialEmailError = appContainer!.dataset.socialEmailError;
  const socialUsername = appContainer!.dataset.socialUsername;
  const socialUsernameError = appContainer!.dataset.socialUsernameError;

  const routes = [
    { path: "/", component: IndexView, name: "index" },
    {
      path: "/znajdz-objawy/",
      component: FindSymptoms,
      name: "find-symptoms",
      meta: { hideFooter: true },
    },
    { path: "/usterka/:faultId/", component: FaultView, name: "fault-detail" },
    {
      path: "/znajdz-naprawe/",
      component: FindRepair,
      name: "find-repairs",
      meta: { hideFooter: true },
    },
    {
      path: "/naprawa/:repairId",
      component: RepairView,
      name: "repair-detail",
    },
    {
      path: "/profil/",
      component: Profile,
      name: "profile",
    },
    {
      path: "/wyceny-napraw/",
      component: TecEstimateList,
      name: "tec-estimate-list-no-car",
    },
    {
      path: "/wyceny-napraw/:typeId/",
      component: TecEstimateList,
      name: "tec-estimate-list",
    },
    {
      path: "/wycena-naprawy/:typeId/:korId/:itemMpId/",
      component: TecEstimateDetail,
      name: "tec-estimate-detail",
    },
    {
      path: "/wycena-naprawy/:typeId/:korId/:itemMpId/:workId/",
      component: TecEstimateVariant,
      name: "tec-estimate-variant",
    },
    {
      path: "/accounts/social/signup/",
      component: SocialSignUp,
      name: "finish-signup",
      props: {
        csrf,
        socialEmail,
        socialEmailError,
        socialUsername,
        socialUsernameError,
      },
    },
    {
      path: "/konto/zaloguj-sie/",
      component: LoginView,
      name: "login",
    },
    {
      path: "/konto/zarejestruj-sie/",
      component: RegistrationView,
      name: "register",
    },
    {
      path: "/konto/zresetuj-haslo/:uidb64/:token/",
      component: NewPasswordView,
      name: "new-password",
    },
    {
      path: "/konto/zresetuj-haslo/",
      component: ForgotPasswordView,
      name: "forgot-password",
    },
    {
      path: "/konto/aktywacja/:uidb64/:token/",
      component: ActivationView,
      name: "activation",
    },
    {
      path: "/ustawienia-cookies/",
      component: CookiesDeclarationSettings,
      name: "cookies-declaration-settings",
    },
    { path: "/accounts/social/connections/", redirect: { name: "profile" } },
    { path: "/:pathMatch(.*)*", component: NotFound, name: "not-found" },
  ];

  return createVueRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to) {
      if (to.hash) {
        return {
          el: to.hash,
          behaviour: "smooth",
        };
      } else {
        return { top: 0, behaviour: "auto" };
      }
    },
  });
}
